import React, { FC } from 'react';
import { graphql } from 'react-relay';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { RelayFragment } from 'src/shared/types';
import { useProductConfigurationState } from '../../state';
import { productProvider_listItem$data } from '../../state/queries/__generated__/productProvider_listItem.graphql';
import ImportCatalogPaginationFragment from './importCatalogPaginationFragment';
import { importCatalogListQuery } from './__generated__/importCatalogListQuery.graphql';

const ImportCatalogListQuery: FC<{
    search: string;
    category: string | null;
    onProductClick: (providerProduct: Omit<RelayFragment<productProvider_listItem$data>, ' $fragmentType'>) => void;
}> = ({ search, category: selectedCategory, onProductClick }) => {
    const { state } = useProductConfigurationState();
    const category = selectedCategory ? (selectedCategory.indexOf('c_') === 0 ? selectedCategory.substring(2) : null) : null;
    const macroCategory = selectedCategory ? (selectedCategory.indexOf('m_') === 0 ? selectedCategory.substring(2) : null) : null;

    const query = useLazyLoadQuery<importCatalogListQuery>(
        graphql`
            query importCatalogListQuery($provider: ProductProvider!, $category: String, $macroCategory: String) {
                ...importCatalogPaginationFragment__providerProducts @arguments(provider: $provider, category: $category, macroCategory: $macroCategory)
            }
        `,
        {
            provider: state.provider,
            macroCategory,
            category
        }
    );

    return (
        <ImportCatalogPaginationFragment
            query={query}
            search={search}
            category={selectedCategory}
            macroCategory={macroCategory}
            onProductClick={onProductClick}
        />
    );
};

export default ImportCatalogListQuery;
